import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Button,
} from '@mui/material';
import React from 'react';
import {useGetTradeTermsQuery} from 'api';
import AddIcon from '@mui/icons-material/Add';
import TradeTermDeleteIconButton from './TradeTermDeleteIconButton';
import CreateTradeTermModal from './TradeTermCreateModal';
import TradeTermEditIconButton from './TradeTermEditIconButton';

const totalColumns = 3;

function TradeTermsTable() {
  const {data, isLoading, isError, isSuccess} = useGetTradeTermsQuery();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <CreateTradeTermModal
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
        }}
      />
      <TableContainer component={Paper}>
        <Table sx={{minWidth: 650}} aria-label="TradeTerm Table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={totalColumns - 1}>TradeTerm</TableCell>
              <TableCell align="right">
                <Button
                  onClick={() => {
                    setIsOpen(true);
                  }}
                  disableElevation
                  variant="contained"
                  endIcon={<AddIcon />}
                >
                  Add
                </Button>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="center">Title</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isSuccess &&
              Boolean(data?.length) &&
              data.map(row => (
                <TableRow key={row._id} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                  <TableCell component="th" scope="row">
                    {row._id}
                  </TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="center">
                    <TradeTermEditIconButton tradeTerm={row} />
                    <TradeTermDeleteIconButton tradeTermId={row._id} />
                  </TableCell>
                </TableRow>
              ))}
            {Boolean(isSuccess && !data?.length) && (
              <TableRow>
                <TableCell colSpan={totalColumns}>No TradeTerm found</TableCell>
              </TableRow>
            )}
            {isError && (
              <TableRow>
                <TableCell colSpan={totalColumns}>
                  <Typography color="error">Failed to fetch TradeTerms.</Typography>
                </TableCell>
              </TableRow>
            )}
            {isLoading && (
              <TableRow>
                {Array.from(Array(totalColumns).keys()).map(key => (
                  <TableCell key={key}>
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default TradeTermsTable;
